// src/Components/projectsData.js
import smartlow2 from '../assests/smartlow-2.jpg';
import omaralfakihi from '../assests/omaralfakihi.jpeg';
import steptowear from '../assests/steptowear.jpeg';

export const ProjectsListAR = [
  // {
  //   id: 1,
  //   title: 'مصنع فلز للحديد',
  //   img: flzImg,
  //   description: 'قمنا بتصميم هوية بصرية لمصنع فلز للحديد حيث قمنا بتصميم الهوية البصرية بأشكال والوان تشرح بيئة العمل ونشاطه',
  // },
  {
    id: 2,
    title: 'LglTech',
    img: smartlow2,
    description: 'مساعد تقني ينجز المهام المكتبية للمحامين ويسهل عملهم من جميع الجوانب',
    link: 'https://lgltech.mptech.com.sa/' // إضافة حقل الرابط
  },
  {
    id: 3,
    title: 'موقع تعريفي',
    img: omaralfakihi,
    description: 'قمنا ببناء موقع تعريفي للمحاماة وايضا تصميم الهوية البصرية وتحسين محركات البحث للموقع',
  },
  {
    id: 4,
    title: 'موقع الكتروني',
    img: steptowear,
    description: 'قمنا بادارة الموقع على سلة واطلاق الحملات الاعلانية الخاصة به وتصميم الشعار والهوية البصرية واعداد خطة تسويقية تتناسب مع نشاط الموقع',
  },
];

export const ProjectsListEN = [
  // {
  //   id: 1,
  //   title: 'FLZ Factory',
  //   img: flzImg,
  //   description: 'We have desinged FLZ\'s factory Visual Identity designing a brand identity with shapes and colors that reflect the work environment and the nature of its operations.',
  // },
  {
    id: 2,
    title: 'LglTech',
    img: smartlow2,
    description: 'A technical assistant that completes office tasks for lawyers and facilitates their work in all aspects',
    link: 'https://lgltech.mptech.com.sa/' // إضافة حقل الرابط
  },
  {
    id: 3,
    title: 'Profile website',
    img: omaralfakihi,
    description: 'We developed a professional website for the law practice, along with branding/visual identity design and search engine optimization (SEO).',
  },
  {
    id: 4,
    title: 'E-commerce site',
    img: steptowear,
    description: 'We handled the website management on Salla e-commerce platform, executed dedicated ad campaigns, created the logo & brand identity, and implemented a customized marketing strategy aligned with the site\'s objectives',
  },
];